import { useState } from 'react';
import { Link } from 'react-router-dom';
import '../styles/auth.css';
import { apiUrl } from '../utils/resolveUrl';

export default function Register() {
  const [name, setName] = useState('');
  const [surname, setSurname] = useState('');
  const [username, setUsername] = useState('');
  const [file, setFile] = useState(null);
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [acceptTerms, setAcceptTerms] = useState(false);
  const [country, setCountry] = useState('');
  const [stateProvince, setStateProvince] = useState('');
  const [city, setCity] = useState('');
  const [zip, setZip] = useState('');
  const [streetAddress, setStreetAddress] = useState('');
  const [dateOfBirth, setDateOfBirth] = useState('');
  const [gender, setGender] = useState('');
  const [marketingEmail, setMarketingEmail] = useState(false);
  const [marketingSMS, setMarketingSMS] = useState(false);
  const [preferredCurrency, setPreferredCurrency] = useState('ALL');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState(''); // 'error' or 'success'
  const [validationErrors, setValidationErrors] = useState({});

  const handleSubmit = async (e) => {
    e.preventDefault();
    setMessage('');
    setMessageType('');
    setValidationErrors({});
    const errs = {};
    const vUsername = (username || '').trim();
    const vName = (name || '').trim();
    const vSurname = (surname || '').trim();
    const vEmail = (email || '').trim();
    const vPassword = password || '';
    const vConfirm = confirmPassword || '';
    const vPhone = (phoneNumber || '').trim();
    const vAccept = (acceptTerms === true || acceptTerms === 'true');

    if (!vUsername) errs.username = 'Username is required';
    if (!vName) errs.name = 'First name is required';
    if (!vSurname) errs.surname = 'Last name is required';
    if (!vEmail) errs.email = 'Email is required';
    else if (!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(vEmail)) errs.email = 'Invalid email';
    if (!vPassword) errs.password = 'Password is required';
    if (!vConfirm) errs.confirmPassword = 'Please confirm password';
    if (vPassword && vConfirm && vPassword !== vConfirm) errs.confirmPassword = 'Passwords do not match';
    if (!vPhone) errs.phoneNumber = 'Phone number is required';
    if (!vAccept) errs.acceptTerms = 'You must accept terms and conditions';
    if (Object.keys(errs).length) {
      setValidationErrors(errs);
      console.warn('Register validation errors:', errs);
      const labels = Object.keys(errs).map(k => errs[k]);
      setMessage('Please fix highlighted fields: ' + labels.join('; '));
      setMessageType('error');
      // focus first invalid input for better visibility
      setTimeout(() => {
        const first = document.querySelector('.input-invalid');
        if (first && typeof first.focus === 'function') first.focus();
      }, 20);
      return;
    }
    try {
      const fd = new FormData();
      fd.append('name', name);
      fd.append('surname', surname);
      fd.append('username', username);
      fd.append('email', email);
      fd.append('password', password);
      fd.append('confirmPassword', confirmPassword);
      fd.append('phoneNumber', phoneNumber);
      fd.append('acceptTerms', acceptTerms);
      fd.append('country', country);
      fd.append('stateProvince', stateProvince);
      fd.append('city', city);
      fd.append('zip', zip);
      fd.append('streetAddress', streetAddress);
      if (dateOfBirth) fd.append('dateOfBirth', dateOfBirth);
      if (gender) fd.append('gender', gender);
      fd.append('marketingEmail', marketingEmail);
      fd.append('marketingSMS', marketingSMS);
      fd.append('preferredCurrency', preferredCurrency);
      if (file) fd.append('profileImage', file);

      const res = await fetch(apiUrl('auth/register'), {
        method: 'POST',
        credentials: 'include',
        body: fd,
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) {
        setMessage(data.message || 'Regjistrimi dështoi');
        setMessageType('error');
        return;
      }
      if (data.token) localStorage.setItem('token', data.token);
      setMessage(data.message || 'I regjistruar');
      setMessageType('success');
    } catch (err) {
      console.error(err);
      setMessage('Regjistrimi dështoi');
      setMessageType('error');
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card auth-card-wide">
        <div className="auth-icon-badge">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M16 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
            <circle cx="8.5" cy="7" r="4" />
            <line x1="20" y1="8" x2="20" y2="14" />
            <line x1="23" y1="11" x2="17" y2="11" />
          </svg>
        </div>
        <h2 className="auth-title">Krijo llogari</h2>
        <p className="auth-sub">Plotësoni të dhënat tuaja për të filluar me Globe.</p>
        <form onSubmit={handleSubmit} className="auth-form">
          <div>
            <label className="required-label">Emri i përdoruesit</label>
            <input className={`auth-input ${validationErrors.username ? 'input-invalid' : ''}`} placeholder="Emri i përdoruesit" value={username} onChange={e => setUsername(e.target.value)} />
            {validationErrors.username && <div className="field-error">{validationErrors.username}</div>}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ flex: 1 }}>
              <label className="required-label">Emri</label>
              <input className={`auth-input ${validationErrors.name ? 'input-invalid' : ''}`} placeholder="Emri" value={name} onChange={e => setName(e.target.value)} />
              {validationErrors.name && <div className="field-error">{validationErrors.name}</div>}
            </div>
            <div style={{ flex: 1 }}>
              <label className="required-label">Mbiemri</label>
              <input className={`auth-input ${validationErrors.surname ? 'input-invalid' : ''}`} placeholder="Mbiemri" value={surname} onChange={e => setSurname(e.target.value)} />
              {validationErrors.surname && <div className="field-error">{validationErrors.surname}</div>}
            </div>
          </div>
          <div>
            <label className="required-label">Email</label>
            <input className={`auth-input ${validationErrors.email ? 'input-invalid' : ''}`} placeholder="Email" type="email" value={email} onChange={e => setEmail(e.target.value)} />
            {validationErrors.email && <div className="field-error">{validationErrors.email}</div>}
          </div>
          <div style={{ display: 'flex', gap: 8 }}>
            <div style={{ flex: 1 }}>
              <label className="required-label">Fjalëkalimi</label>
              <input className={`auth-input ${validationErrors.password ? 'input-invalid' : ''}`} placeholder="Fjalëkalimi" type="password" value={password} onChange={e => setPassword(e.target.value)} />
              {validationErrors.password && <div className="field-error">{validationErrors.password}</div>}
            </div>
            <div style={{ flex: 1 }}>
              <label className="required-label">Konfirmo fjalëkalimin</label>
              <input className={`auth-input ${validationErrors.confirmPassword ? 'input-invalid' : ''}`} placeholder="Konfirmo fjalëkalimin" type="password" value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)} />
              {validationErrors.confirmPassword && <div className="field-error">{validationErrors.confirmPassword}</div>}
            </div>
          </div>
          <div>
            <label className="required-label">Telefoni (+kodi i shtetit)</label>
            <input className={`auth-input ${validationErrors.phoneNumber ? 'input-invalid' : ''}`} placeholder="Telefoni (+kodi i shtetit)" value={phoneNumber} onChange={e => setPhoneNumber(e.target.value)} />
            {validationErrors.phoneNumber && <div className="field-error">{validationErrors.phoneNumber}</div>}
          </div>

          <textarea className="auth-input" placeholder="Adresa (duke përfshirë apartamentin, ndërtesën)" rows={2} value={streetAddress} onChange={e => setStreetAddress(e.target.value)} />

          <input className="auth-input" placeholder="Qyteti" value={city} onChange={e => setCity(e.target.value)} />
          <input className="auth-input" placeholder="Qarku / Provinca" value={stateProvince} onChange={e => setStateProvince(e.target.value)} />
          <input className="auth-input" placeholder="Kodi Postar" value={zip} onChange={e => setZip(e.target.value)} />
          <input className="auth-input" placeholder="Shteti" value={country} onChange={e => setCountry(e.target.value)} />

          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            <label style={{ flex: 1 }}>
              Date of birth
              <input className="auth-input" type="date" value={dateOfBirth} onChange={e => setDateOfBirth(e.target.value)} />
            </label>
            <label style={{ flex: 1 }}>
              Gender
              <select className="auth-input" value={gender} onChange={e => setGender(e.target.value)}>
                <option value="">Prefer not to say</option>
                <option value="female">Female</option>
                <option value="male">Male</option>
                <option value="other">Other</option>
              </select>
            </label>
          </div>

          <div style={{ display: 'flex', gap: 12, alignItems: 'center' }}>
            <label><input type="checkbox" checked={marketingEmail} onChange={e => setMarketingEmail(e.target.checked)} /> Marketing emails</label>
            <label><input type="checkbox" checked={marketingSMS} onChange={e => setMarketingSMS(e.target.checked)} /> Marketing SMS</label>
          </div>

          <label style={{ display: 'block', marginTop: 6 }}>
            Preferred currency
            <select className="auth-input" value={preferredCurrency} onChange={e => setPreferredCurrency(e.target.value)}>
              <option value="ALL">ALL (Local)</option>
              <option value="EUR">EUR</option>
              <option value="USD">USD</option>
            </select>
          </label>

          <label className="file-label">Foto profili (opsionale)
            <input type="file" accept="image/*" onChange={e => setFile(e.target.files?.[0] || null)} />
          </label>

          <label style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <input type="checkbox" checked={acceptTerms} onChange={e => setAcceptTerms(e.target.checked)} /> <span className="required-label" style={{ display: 'inline' }}>Pranoj termat dhe kushtet</span>
          </label>
          {validationErrors.acceptTerms && <div className="field-error">{validationErrors.acceptTerms}</div>}

          <button type="submit" className="auth-submit">Regjistrohuni</button>
          
          {message ? (
            messageType === 'error' ? (
              <div className="auth-error">{message}</div>
            ) : (
              <div className="auth-message">{message}</div>
            )
          ) : null}

          <div className="auth-footer">
            Keni tashmë një llogari? <Link to="/login" className="auth-link-btn">Kyçuni</Link>
          </div>
        </form>
      </div>
    </div>
  );
}
